// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1364":"727973242bb33abd","4945":"142b7082f79cba58","6122":"b0b756de4b932954","8482":"2df968159d721a8e","8870":"ba9b83b24ae648a1","9026":"da21a9a0c23ce884"}[chunkId] + ".css";
};